export const addressFields = [
  'address_1',
  'address_2',
  'city',
  'state',
  'zip',
  'country'
]

/**
 * Checks if a given field name is an address field. It will return true if the field name contains any of the values included in the addressFields array.
 *
 * @param {string} fieldName - The name of the field to check.
 * @returns {boolean} - True if the field name is an address field, false otherwise.
 */
export const isAddressField = (fieldName) => {
  if (!fieldName || typeof fieldName !== 'string') {
    return false
  }
  return addressFields.some((af) => fieldName.includes(af))
}

/**
 * Retrieves any address related data from the provided form data.
 * @param {Array} formData - The form data.
 * @returns {Object} - The address data.
 */
export const getAddressData = (formData) => {
  const addressData = {}
  if (!formData) {
    return addressData
  }
  formData.forEach((field) => {
    if (field && field.name && isAddressField(field.name)) {
      addressData[field.name] = field.initial
    }
  })
  return addressData
}

/**
 * Returns the full a based on the provided field suffix. For example, all address fields have a suffix of '_address_1', '_address_2', etc. This function will return the field value based on the provided suffix.
 *
 * @param {string} fieldSuffix - The suffix of the field to search for in the address data.
 * @returns {string} - The value of the address field with the provided suffix, or an empty string if not found.
 */
export const getAddressField = (addressData, fieldSuffix) => {
  // Access the keys of addressData correctly
  const fieldName = Object.keys(addressData).find((k) =>
    k.endsWith(fieldSuffix)
  )
  return addressData[fieldName] || ''
}
